// SPDX-License-Identifier: MIT

// Turns the declarative `trackers` specs on each consent type (plain data from
// gatsby-config, e.g. { type: 'facebookPixel', id: '123' }) into real
// onAccept/onReject/onRouteChange callbacks, using the built-in factories. This
// is what lets the whole config live in the plugin's gatsby-config options —
// tracker specs serialize (unlike function callbacks).

const {
  facebookPixel,
  redditPixel,
  intercom,
  combineTrackers,
} = require('./trackers')
const { DEFAULT_CONSENT_TYPE_TEXT } = require('./defaults')

const FACTORIES = { facebookPixel, redditPixel, intercom }

const buildTracker = (specs = []) => {
  const built = specs
    .map((spec) => {
      const factory = FACTORIES[spec.type]
      if (!factory) {
        // eslint-disable-next-line no-console
        console.warn(`gatsby-plugin-cookie-consent: unknown tracker type "${spec.type}"`)
        return null
      }
      return factory(spec.id)
    })
    .filter(Boolean)
  return combineTrackers(built)
}

// Returns { consentTypes, onRouteChange }. For each type: fills in the default
// label/description for its id (unless provided), and builds onAccept/onReject
// from its declarative `trackers`. Also returns a combined route-change handler
// (fires page views on SPA navigation; each is a no-op until consented).
const resolveConsentTypes = (consentTypes = []) => {
  const routeHandlers = []
  const resolved = consentTypes.map((type) => {
    const defaults = DEFAULT_CONSENT_TYPE_TEXT[type.id] || {}
    const { trackers, ...rest } = type
    const resolvedType = {
      ...rest,
      label: type.label || defaults.label || type.id,
      description: type.description || defaults.description || '',
    }
    if (!trackers || trackers.length === 0) return resolvedType
    const tracker = buildTracker(trackers)
    routeHandlers.push(tracker)
    resolvedType.onAccept = tracker.onAccept
    resolvedType.onReject = tracker.onReject
    return resolvedType
  })
  const onRouteChange = () => routeHandlers.forEach((t) => t.onRouteChange())
  return { consentTypes: resolved, onRouteChange }
}

module.exports = { resolveConsentTypes }
